import { get } from 'svelte/store';
import * as PROXY from '../../../common/api.js';
import * as PEGASUS from '@smatch/pegasus-api-docs';
import { AUCTION_STORE, AUCTION_HASH } from './store.js';
import { ORGANIZATION_KEY } from '../../authentication/services/store.js';
const DOMAIN = import.meta.env.VITE_DOMAIN;
export * from './types.js';
/* eslint-disable arrow-body-style */
// Filter Auctions
export const filterAuctions = async (parameters = {}) => {
    if (DOMAIN === 'seller') {
        parameters.organizationKey = get(ORGANIZATION_KEY) ?? '';
    }
    // @ts-expect-error - TODO: Fix Pegasus types
    return PROXY.handleFilter(PEGASUS.filterAuctions, parameters)
        .then(auctions => PROXY.updateStoreBulk(AUCTION_STORE, auctions));
};
// Filter Mini Auctions
export const filterMiniAuctions = async (parameters = {}) => {
    if (DOMAIN === 'seller') {
        parameters.organizationKey = get(ORGANIZATION_KEY) ?? '';
    }
    return PROXY.handleFilter(PEGASUS.filterMiniAuctions, parameters);
};
// Fetch Auction
export const fetchAuction = async (keys, onError) => {
    return PROXY.handleFetch(PEGASUS.fetchAuction, keys)
        .then(({ data, statusCode }) => {
        if (onError?.(statusCode) === true) {
            return {};
        }
        if (statusCode !== 'STATUS_200') {
            PROXY.handleApiError(statusCode);
            return {};
        }
        return PROXY.updateStore(AUCTION_STORE, null, data);
    });
};
// Create Auction
export const createAuction = async (body) => {
    return PROXY.handleCreate(PEGASUS.createAuction, body)
        .then(response => PROXY.updateStore(AUCTION_STORE, AUCTION_HASH, response));
};
// Update Auction
export const updateAuction = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateAuction, keys, body)
        .then(response => PROXY.updateStore(AUCTION_STORE, AUCTION_HASH, response));
};
// Delete Auction
export const deleteAuction = async (keys) => {
    return PROXY.handleDelete(PEGASUS.deleteAuction, keys)
        .then(response => PROXY.removeFromStore(AUCTION_STORE, AUCTION_HASH, keys.auctionKey, response));
};
// Update Auction State
// eslint-disable-next-line max-len
export const updateAuctionState = async (keys, body) => {
    // eslint-disable-next-line max-len
    return PROXY.handleUpdate(PEGASUS.updateAuctionState, keys, body)
        .then(response => PROXY.updateStore(AUCTION_STORE, AUCTION_HASH, response));
};
export const listAuctionFilters = async (parameters = {}) => {
    return PROXY.handleFetchQuery(PEGASUS.filterListAuctions, parameters);
};
export const downloadAuction = async (keys) => {
    return PROXY.handleDownload(PEGASUS.exportAuctionVariants, keys);
};
export const generateExportFile = async (keys, body) => {
    return PROXY.handleSend(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    PEGASUS.generateAuctionExportFile, keys, body).then(({ data, statusCode }) => {
        if (statusCode !== 'STATUS_200') {
            return data;
        }
        // Linter acting weird... explicit return needed..
        return undefined;
    });
};
// Upload Auction Image
export const uploadAuctionImage = async (keys, body) => PROXY.handleUpload(PEGASUS.importAuctionImage, keys, body);
export const deleteAuctionImage = async (keys) => {
    return PROXY.handleDelete(PEGASUS.deleteAuctionImage, keys);
};
// Send Auction Subscription Mail
// eslint-disable-next-line max-lines-per-function
export const sendAuction = async (keys, body, onError) => {
    return PROXY.handleSend(PEGASUS.sendAuction, keys, body).then(({ data, statusCode }) => {
        if (onError?.(statusCode) === true) {
            return data;
        }
        if (statusCode !== 'STATUS_204') {
            PROXY.handleApiError(statusCode);
            return data;
        }
        return data;
    });
};
/* eslint-enable arrow-body-style */ 
